import { ReactElement } from 'react';

import { Address } from '@dreryk/address-common-api';

import { useBoolean } from '@dreryk/react-common';

import { PatientAddressModal } from './PatientAddressModal';

type PatientAddressModalOpenerChildrenRenderProps = {
   openModal: VoidFunction;
};

type PatientAddressModalOpenerProps = {
   children: (renderProps: PatientAddressModalOpenerChildrenRenderProps) => ReactElement;
   patientId: number;
   patientAddress: Address | undefined;
};

export const PatientAddressModalOpener = (props: PatientAddressModalOpenerProps): ReactElement => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   return (
      <>
         {modalOpened ? (
            <PatientAddressModal
               patientAddress={props.patientAddress}
               patientId={props.patientId}
               onClose={closeModal}
            />
         ) : null}
         {props.children({ openModal: openModal })}
      </>
   );
};
